import * as React from 'react';

import {TwoLine} from '../../two-line/two-line';

import styles from './details-list.module.css';

type Detail = {
    name: any;
    value: any;
    key: string;
    isFullWidth?: boolean;
};

type Props = {
    details: Detail[];
    padding?: number;
};

export function DetailsList(props: Props) {
    return (
        <div style={{padding: props.padding}} className={styles['details-list']}>
            {props.details.map((detail) => {
                const {name, value, key, isFullWidth = true} = detail;

                return (
                    <div
                        key={key}
                        className={isFullWidth ? styles['detail--full'] : styles['detail--half']}
                    >
                        <TwoLine
                            topRow={<div className={styles['detail-name']}>{name}</div>}
                            bottomRow={<div className={styles['detail-value']}>{value}</div>}
                        />
                    </div>
                );
            })}
        </div>
    );
}
